import React from 'react';
import { Route, Redirect, Switch, BrowserRouter } from 'react-router-dom';
import { addLocale } from 'primereact/api';
import { isAdmin, isAuthenticated, removeAuthData } from './service/auth';

import Header from './components/Header';

import Dashboard from './pages/Dashboard';
import Truck from './pages/Truck/';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import Driver from './pages/Driver';
import Expense from './pages/Expense';
import RoutePage from './pages/Route';
import Viability from './pages/Viability';
import ViabilityCreate from './pages/Viability/create';
import Stock from './pages/Stock';
import StockList from './pages/StockList';
import Param from './pages/Param';
import TireControl from './pages/TireControl';
import PartControl from './pages/PartControl';
import Travel from './pages/Travel';
import TravelDetail from './pages/TravelDetail';
import ChangeDefaultPassword from './pages/User/ChangeDefaultPassword';
import Supplier from './pages/Supplier';
import ExpenseCategory from './pages/ExpenseCategory';
import Payment from './pages/Payment';
import NotFound from './pages/NotFound';
import TrafficTicket from './pages/TrafficTicket';
import RequestRecoveryPassword from './pages/RequestRecoveryPassword';
import ValidateRecoveryPassword from './pages/ValidateRecoveryPassword';
import Terms from './pages/Terms';

import calendarTranslate from './assets/calendar-translate.json';

import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'prismjs/themes/prism-coy.css';
import './assets/layout/layout.scss';

const WithHeader = (Page) => {
    return(
        <Header><Page /></Header>
    );
}

function PrivateRoute({
    component: Component,  ...rest
}){
    return (
        <Route 
            {...rest}
            render={(props) => {
                if(isAuthenticated()) {
                    if(rest.isAdmin && !isAdmin()) return <Redirect to={{ pathname: '/', state: { from: props.location }}} />;
                    if(rest.hasHeader) return WithHeader(Component);
                    return <Component />;
                } else return <Redirect to={{ pathname: '/', state: { from: props.location }}} />;
            }}
        />
    );
}

const App = () => {
    addLocale('pt-br', calendarTranslate);

    return(
        <BrowserRouter>
            <Switch>
                <Route path="/" exact render={() => <SignIn />} />
                <Route path="/signin" exact render={() => <SignIn />} />
                <Route path="/request/recovery/password" exact render={() => <RequestRecoveryPassword />} />
                <Route path="/user/validate/password/:token" exact render={() => <ValidateRecoveryPassword />} />
                <Route path="/signup" exact render={() => <SignUp />} />
                <Route path="/terms" exact render={() => <Terms />} />
                <Route path="/signout" exact render={() => {
                    removeAuthData();
                    return <SignIn />;
                }} />
                <PrivateRoute path="/change/default/password" component={ChangeDefaultPassword} />
                <PrivateRoute isAdmin hasHeader path="/dashboard" component={Dashboard} />
                <PrivateRoute isAdmin hasHeader path="/truck" component={Truck} />
                <PrivateRoute hasHeader path="/travel" exact component={Travel} />
                <PrivateRoute hasHeader path="/travel/detail/:code" exact component={TravelDetail} />
                <PrivateRoute isAdmin hasHeader path="/driver" component={Driver} />
                <PrivateRoute isAdmin hasHeader path="/supplier" component={Supplier} />
                <PrivateRoute isAdmin hasHeader path="/expensecategory" component={ExpenseCategory} />
                <PrivateRoute isAdmin hasHeader path="/route" component={RoutePage} />
                <PrivateRoute isAdmin hasHeader exact path="/viability" component={Viability} />
                <PrivateRoute isAdmin hasHeader path="/viability/create" component={ViabilityCreate} />
                <PrivateRoute isAdmin hasHeader path="/viability/:code" component={ViabilityCreate} />
                <PrivateRoute isAdmin hasHeader exact path="/stock" component={Stock} />
                <PrivateRoute isAdmin hasHeader path="/stock/list/:code" component={StockList} />
                <PrivateRoute isAdmin hasHeader path="/param" component={Param} />
                <PrivateRoute isAdmin hasHeader path="/expense" component={Expense} />
                <PrivateRoute isAdmin hasHeader path="/tirecontrol" component={TireControl} />
                <PrivateRoute isAdmin hasHeader path="/partcontrol" component={PartControl} />
                <PrivateRoute isAdmin hasHeader path="/payment" component={Payment} />
                <PrivateRoute isAdmin hasHeader path="/trafficticket" component={TrafficTicket} />
                <Route path="/404" component={NotFound} />
                <Redirect to="/404" />
            </Switch>
        </BrowserRouter>
        
        
    );
}

export default App;
